import React from "react";
import { Trans, useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { DocumentationLink } from "components/support";
import DocsHelper from "util/DocsHelper";
import useSearchVersionCheck from "hooks/useSearchVersionCheck";
import { ExternalLink } from "components/common";
const StyledUl = styled.ul(
  ({ theme }) => css`
    padding-left: 20px;
    list-style-type: disc;

    > li {
      margin-bottom: ${theme.spacings.sm};
    }
    > li:last-child {
      margin-bottom: 0;
    }
  `
);
const S3_ACCESS_KEY = "s3_client_default_access_key";
const S3_SECRET_KEY = "s3_client_default_secret_key";
const S3_ENDPOINT = "s3_client_default_endpoint";
const GCS_CREDENTIALS_FILE = "gcs_credentials_file";
const PATH_REPO = "path_repo";
const CONFIG_KEY_VALUES = {
  s3AccessKey: S3_ACCESS_KEY,
  s3SecretKey: S3_SECRET_KEY,
  s3Endpoint: S3_ENDPOINT,
  gcsCredentialsFile: GCS_CREDENTIALS_FILE,
  pathRepo: PATH_REPO
};
const WarmTierRepositorySetupText = () => {
  const { t } = useTranslation("enterprise_data_tiering");
  const { data, isLoading } = useSearchVersionCheck("datanode");
  const showDataNodeText = !isLoading && (data == null ? void 0 : data.satisfied);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, t("repository_setup.locations_hidden")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "repository_setup.documented_fully",
      components: {
        docsLink: /* @__PURE__ */ React.createElement(
          DocumentationLink,
          {
            page: DocsHelper.PAGES.DATA_TIERING_WARM_TIER_SETUP,
            text: t("repository_setup.here")
          }
        )
      }
    }
  )), /* @__PURE__ */ React.createElement("p", null, t("repository_setup.in_summary")), showDataNodeText ? /* @__PURE__ */ React.createElement(StyledUl, null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "repository_setup.datanode.gcs_key_location", components: { strong: /* @__PURE__ */ React.createElement("strong", null) } })), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "repository_setup.datanode.config_keys",
      values: CONFIG_KEY_VALUES,
      components: { strong: /* @__PURE__ */ React.createElement("strong", null), code: /* @__PURE__ */ React.createElement("code", null), lineBreak: /* @__PURE__ */ React.createElement("br", null) }
    }
  )), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "repository_setup.datanode.restart", components: { strong: /* @__PURE__ */ React.createElement("strong", null) } })), /* @__PURE__ */ React.createElement("li", null, t("repository_setup.return_to_page"))) : /* @__PURE__ */ React.createElement(StyledUl, null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "repository_setup.opensearch.install_plugins", components: { strong: /* @__PURE__ */ React.createElement("strong", null) } })), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "repository_setup.opensearch.s3_keystore",
      components: {
        strong: /* @__PURE__ */ React.createElement("strong", null),
        s3DocsLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://docs.opensearch.org/docs/2.13/tuning-your-cluster/availability-and-recovery/snapshots/snapshot-restore/#register-repository" })
      }
    }
  )), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "repository_setup.opensearch.gcs_keystore",
      components: {
        gcsDocsLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://opster.com/guides/opensearch/opensearch-operations/how-to-set-up-snapshot-repositories/#How-to-configure-a-snapshot-repository-for-Google-Cloud-Storage" })
      }
    }
  )), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "repository_setup.opensearch.config_changes", components: { strong: /* @__PURE__ */ React.createElement("strong", null) } })), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "repository_setup.opensearch.restart", components: { strong: /* @__PURE__ */ React.createElement("strong", null) } })), /* @__PURE__ */ React.createElement("li", null, t("repository_setup.return_to_page"))));
};
export default WarmTierRepositorySetupText;
